<template>
  <el-card shadow="never" class="aui-card--fill">
    <div class="mod-trade__worklog}">
      <el-form
        :inline="true"
        :model="dataForm"
        @keyup.enter.native="getDataList()"
      >
        <el-form-item label="合同编号：">
          <el-input
            v-model="dataForm.agreementCode"
            placeholder="合同编号"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="员工：" prop="workerId">
          <CommonDrop
            v-model="dataForm.workerId"
            url="/trade/worker/list"
            :autoDefault="false"
          ></CommonDrop>
        </el-form-item>
        <el-form-item label="日期：">
          <el-date-picker
            v-model="dateArr"
            type="daterange"
            range-separator="至"
            value-format="yyyy-MM-dd"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button @click="reload()">{{ $t("query") }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button
            v-if="$hasPermission('trade:worklog:save')"
            type="primary"
            @click="addOrUpdateHandle()"
            >上传工票</el-button
          >
        </el-form-item>
      </el-form>
      <el-table
        v-loading="dataListLoading"
        :data="dataList"
        border
        @selection-change="dataListSelectionChangeHandle"
        style="width: 100%;"
      >
        <el-table-column
          type="index"
          label="行号"
          header-align="center"
          align="center"
          width="50"
        ></el-table-column>
        <el-table-column
          prop="agreementCode"
          label="合同编号"
          header-align="center"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="workerName"
          label="员工姓名"
          header-align="center"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="productCode"
          label="品番号"
          header-align="center"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="productName"
          label="品名"
          header-align="center"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="color"
          label="颜色"
          header-align="center"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="size"
          label="规格"
          header-align="center"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="technologyName"
          label="工序"
          header-align="center"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="count"
          label="数量"
          header-align="center"
          align="center"
        ></el-table-column>
      </el-table>
      <el-pagination
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="limit"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="pageSizeChangeHandle"
        @current-change="pageCurrentChangeHandle"
      >
      </el-pagination>
    </div>
  </el-card>
</template>

<script>
import CommonDrop from "@/components/CommonDrop";
import mixinViewModule from "@/mixins/view-module";
import moment from 'moment'
export default {
  mixins: [mixinViewModule],
  components: {
    CommonDrop,
  },
  data() {
    return {
      dateArr: [],
      mixinViewModuleOptions: {
        getDataListURL: "/trade/worklog/report",
        getDataListIsPage: true,
        exportURL: "/trade/worklog/export",
        deleteURL: "/trade/worklog",
        deleteIsBatch: true,
      },
      dataForm: {
        workerId: "",
        agreementCode: "",
        beginDate:'',
        endDate:'',
      },
    };
  },
  watch: {
    dateArr(newVal) {
      if (newVal && newVal.length === 2) {
        this.dataForm.beginDate = newVal[0];
        this.dataForm.endDate = newVal[1];
      } else {
        this.dataForm.beginDate = "";
        this.dataForm.endDate = "";
      }
      this.currentId = "";
      this.reload();
    },
  },
  mounted(){
this.dateArr=[moment().subtract(30,'day').format('yyyy-MM-DD'),moment().format('yyyy-MM-DD')]
  }
};
</script>
